import { Component } from "@angular/core";

@Component({
  selector: "app-logo-company-testimonial",
  templateUrl: "logo-company-testimonial.component.html",
})
export class LogoCompanyTestimonialComponent {}
